import { render, staticRenderFns } from "./ModalGroupCategories.vue?vue&type=template&id=b17163d4&scoped=true&"
import script from "./ModalGroupCategories.vue?vue&type=script&lang=js&"
export * from "./ModalGroupCategories.vue?vue&type=script&lang=js&"
import style0 from "./ModalGroupCategories.vue?vue&type=style&index=0&id=b17163d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17163d4",
  null
  
)

export default component.exports